import script from "./MyAccount.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyAccount.vue?vue&type=script&lang=ts&setup=true"

import "./MyAccount.vue?vue&type=style&index=0&id=2ba4ae59&lang=css"

export default script